import {useMutation, gql} from '@apollo/client'

export const MUTATE_SAVE_USER_PREFERENCES = gql`
  mutation MUTATE_SAVE_USER_PREFERENCES($columns: [String!]!, $azureRole: String) {
    saveUserPreference(columns: $columns, azureRole: $azureRole) {
      success
    }
  }
`

export function useSaveUserPreferences() {
  return useMutation(MUTATE_SAVE_USER_PREFERENCES, {
    fetchPolicy: 'no-cache',
    errorPolicy: 'all'
  })
}
